import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PropTypes as AmktCommonPropTypes } from '@atlassian/amkt-common';
import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ANALYTICS_EVENT_SOURCE_APP_TILE } from '../../../AddonDiscovery/constants/analytics/events';
import AddonDiscoveryPropTypes from '../../../AddonDiscovery/constants/proptypes/AddonDiscoveryPropTypes';
import CommonPropTypes from '../../constants/proptypes/CommonPropTypes';
import LargeHit from './LargeHit';
import SmallHit from './SmallHit';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ResponsiveHit extends Component {
  render() {
    var _this$props$hit, _this$props$hit2;
    const analyticsContextAttributes = {
      source: ANALYTICS_EVENT_SOURCE_APP_TILE,
      appName: (_this$props$hit = this.props.hit) === null || _this$props$hit === void 0 ? void 0 : _this$props$hit.getIn(['name']),
      vendorName: (_this$props$hit2 = this.props.hit) === null || _this$props$hit2 === void 0 ? void 0 : _this$props$hit2.getIn(['vendor', 'name'])
    };
    return this.props.screenClass === 'xs' ? /*#__PURE__*/_jsx(SmallHit, {
      colSpan: this.props.colSpan,
      contentOverride: this.props.contentOverride,
      fromSearch: this.props.fromSearch,
      hit: this.props.hit,
      hitContext: this.props.hitContext,
      perspective: this.props.perspective,
      screenClass: this.props.screenClass,
      hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
      hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
      filters: this.props.filters,
      sectionTitle: this.props.sectionTitle
    }) :
    /*#__PURE__*/
    _jsx(MarketplaceAnalyticsContext, {
      attributes: analyticsContextAttributes,
      children: /*#__PURE__*/_jsx(LargeHit, {
        colSpan: this.props.colSpan,
        contentOverride: this.props.contentOverride,
        fromSearch: this.props.fromSearch,
        hit: this.props.hit,
        hitContext: this.props.hitContext,
        onCategoryClick: this.props.onCategoryClick,
        perspective: this.props.perspective,
        screenClass: this.props.screenClass,
        stateChangeRequested: this.props.stateChangeRequested,
        overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
        hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
        hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
        filters: this.props.filters,
        sectionTitle: this.props.sectionTitle
      })
    });
  }
}
_defineProperty(ResponsiveHit, "propTypes", {
  colSpan: CommonPropTypes.colSpan.isRequired,
  contentOverride: PropTypes.node,
  fromSearch: PropTypes.bool.isRequired,
  hit: AmktCommonPropTypes.requiredIf(CommonPropTypes.hit(), props => !props.contentOverride),
  hitContext: AmktCommonPropTypes.requiredIf(CommonPropTypes.hitContext, props => !props.contentOverride),
  onCategoryClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective,
  screenClass: CommonPropTypes.screenClass.isRequired,
  stateChangeRequested: PropTypes.func,
  overrideLargeHitRightContent: PropTypes.func,
  hasCloudSecurityBadge: PropTypes.bool,
  hasCloudFortifiedBadge: PropTypes.bool,
  filters: CommonPropTypes.filters,
  sectionTitle: PropTypes.string
});